import { useTranslation } from 'react-i18next'
import { YamlPasteField } from './YamlPasteField'

interface ExternalCredentialsBlockProps {
  yamlText: string
  yamlError: string | null
  credentialsFromEnv: boolean
  onYamlChange: (val: string) => void
  onEnvChange: (val: boolean) => void
}

export function ExternalCredentialsBlock({
  yamlText,
  yamlError,
  credentialsFromEnv,
  onYamlChange,
  onEnvChange,
}: ExternalCredentialsBlockProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div className="space-y-4 border-t border-stone-200 pt-4 dark:border-stone-700">
      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          id="credentialsFromEnv"
          checked={credentialsFromEnv}
          onChange={(ev) => {
            onEnvChange(ev.target.checked)
          }}
          className="h-4 w-4 rounded border-stone-300 text-[#5c6e94] focus:ring-[#4e5e82]"
        />
        <label htmlFor="credentialsFromEnv" className="text-sm text-stone-700 dark:text-stone-300">
          {t('velociraptorSettings.install.credentialsFromEnv')}
        </label>
      </div>
      {credentialsFromEnv ? null : (
        <YamlPasteField yamlText={yamlText} yamlError={yamlError} onYamlChange={onYamlChange} />
      )}
    </div>
  )
}
